import APIs from ".";
import { deleteApi, getApi, postApi, putApi } from "../services/axios";

export function getInitiatives({
  selectedPage = 1,
  selectedPageSize = 10,
  ambassadorId = "",
  type = "",
  status = "",
  visibility = "",
}: {
  selectedPage?: number;
  selectedPageSize?: number;
  ambassadorId?: string;
  type?: string;
  status?: string;
  visibility?: string;
}) {
  return async function () {
    const res = await getApi(
      APIs.INITIATIVES.GET_INITIATIVES({
        selectedPage,
        selectedPageSize,
        ambassadorId,
        type,
        status,
        visibility,
      }),
      {
        validateUser: true,
        skipGlobalLoading: true,
      }
    );

    return res;
  };
}

export function getInitiativesForDownload({
  total,
  ambassadorId = "",
  type = "",
  status = "",
  visibility = "",
}: {
  total: number;
  ambassadorId?: string;
  type?: string;
  status?: string;
  visibility?: string;
}) {
  return getApi(
    APIs.INITIATIVES.GET_INITIATIVES({
      selectedPage: 1,
      selectedPageSize: total,
      ambassadorId,
      type,
      status,
      visibility,
    }),
    {
      validateUser: true,
      skipGlobalLoading: true,
      notifySuccess: false,
    }
  );
}

export type CreateInitiativePayload = {
  title: string;
  type: string;
  toolName?: string;
  summary: string;
  plannedDeliveryDate: string;
  isPublic: boolean;
  ambassadorId: string;
};

export type UpdateInitiativePayload = {
  title: string;
  type: string;
  toolName?: string;
  summary: string;
  plannedDeliveryDate: string;
  isPublic: boolean;
};

export function createInitiative(payload: CreateInitiativePayload) {
  return async function () {
    return postApi(APIs.INITIATIVES.CREATE, payload, {
      validateUser: true,
      notifySuccess: true,
    });
  };
}

export function updateInitiative(id: string, payload: UpdateInitiativePayload) {
  return async function () {
    return putApi(APIs.INITIATIVES.UPDATE(id), payload, {
      validateUser: true,
      notifySuccess: true,
    });
  };
}

export function deleteInitiative(id: string) {
  return async function () {
    return deleteApi(
      APIs.INITIATIVES.DELETE(id),
      {},
      {
        validateUser: true,
        notifySuccess: true,
      }
    );
  };
}

export function getObjectiveSuggestion(payload: {
  description?: string;
  title?: string;
  type?: string;
  summary?: string;
}) {
  return async function () {
    return postApi(APIs.INITIATIVES.SUGGEST_OBJECTIVE, payload, {
      validateUser: true,
      notifySuccess: false,
      notifyError: true,
      skipGlobalLoading: true,
    });
  };
}
